import styled from 'styled-components'

const Button = styled.button`
    display: inline-block;
    color: white; 
    cursor: pointer;
    text-decoration: none !important;
    background: hsl(234.9, 100%, 63.1%);
    border: 2px solid hsl(234.9, 100%, 63.1%);
    font-size: 18px;
    padding: 12px 16px;

    :hover {
        background: hsl(234.9, 100%, 60.1%);
        border: 2px solid #4353FF;
    }

    :active,
    :focus {
        border-color: #4353FF;
        outline: 3px solid #D9DDFF;
        outline-offset: 0

    }
`

export default Button
